// src/hooks/useTheme.js
import { useEffect, useState, useCallback } from 'react';

const THEME_KEY = 'alsatuu:theme';

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  // Меняем StatusBar если есть Capacitor
  try {
    // eslint-disable-next-line
    const { StatusBar, Style } = require('@capacitor/status-bar');
    if (StatusBar) {
      StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light });
      StatusBar.setBackgroundColor({ color: theme === 'dark' ? '#0B0B10' : '#FAFAFA' });
    }
  } catch (e) { /* нет capacitor — ок */ }
}

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem(THEME_KEY) || 'light';
  });

  useEffect(() => { applyTheme(theme); }, [theme]);

  const setAndSave = useCallback((t) => {
    localStorage.setItem(THEME_KEY, t);
    setTheme(t);
  }, []);

  const toggle = useCallback(() => setAndSave(theme === 'dark' ? 'light' : 'dark'), [theme, setAndSave]);

  return { theme, setTheme: setAndSave, toggle };
}
